module.exports = __webpack_public_path__ + "img/worldox.e1ab8666.png";